module.exports = __webpack_public_path__ + "static/media/download.ba3ec7cf.png";